<template>
  <v-container fluid>
    <div class="toolbar d-flex flex-row justify-space-between align-center elevation-3 mb-3">
      <span>
        Flash Express Setting
      </span>
      <div
        class="d-flex flex-row align-center"
        style="gap: 0.625rem;">
        <v-btn
          color="error"
          outlined
          rounded
          small
          :loading="loading"
          @click="onReset()">
          {{ $t('button.Reset') }}
        </v-btn>
        <v-btn
          color="success"
          rounded
          small
          :loading="loading"
          @click="onSubmit()">
          {{ $t('button.Save') }}
        </v-btn>
      </div>
    </div>
    <validation-observer
      ref="form"
      @submit.prevent="onSubmit()">
      <v-row class="px-8">
        <v-col
          cols="12"
          class="card-container elevation-3">
          <v-row>
            <v-col
              cols="12"
              class="card-title">
              Pickup Address
            </v-col>
            <v-col
              cols="12"
              md="6">
              <gw-text-field
                v-model.trim="formData.pickUpAddress.srcName"
                label="Sender Name"
                color="secondary"
                outlined
                dense
                hide-details
                :loading="loading" />
            </v-col>
            <v-col
              cols="12"
              md="6">
              <gw-text-field
                v-model.trim="formData.pickUpAddress.srcPhone"
                label="Phone"
                color="secondary"
                outlined
                dense
                hide-details
                :loading="loading" />
            </v-col>
            <v-col
              cols="12"
              md="6">
              <gw-text-field
                v-model.trim="formData.pickUpAddress.srcProvinceName"
                label="Province"
                color="secondary"
                outlined
                dense
                hide-details
                :loading="loading" />
            </v-col>
            <v-col
              cols="12"
              md="6">
              <gw-text-field
                v-model.trim="formData.pickUpAddress.srcCityName"
                label="District (เขต/อำเภอ)"
                color="secondary"
                outlined
                dense
                hide-details
                :loading="loading" />
            </v-col>
            <v-col
              cols="12"
              md="6">
              <gw-text-field
                v-model.trim="formData.pickUpAddress.srcDistrictName"
                label="Sub-district (แขวง/ตำบล)"
                color="secondary"
                outlined
                dense
                hide-details
                :loading="loading" />
            </v-col>
            <v-col
              cols="12"
              md="6">
              <gw-text-field
                v-model.trim="formData.pickUpAddress.srcPostalCode"
                label="Postal Code"
                color="secondary"
                outlined
                dense
                hide-details
                :loading="loading" />
            </v-col>
            <v-col
              cols="12">
              <gw-text-field
                v-model.trim="formData.pickUpAddress.srcDetailAddress"
                label="Detail Address"
                color="secondary"
                outlined
                dense
                hide-details
                :loading="loading" />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          class="card-container elevation-3">
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="card-title">
              Pick-up Warehouses
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="d-flex justify-end align-center">
              <v-btn
                color="success"
                plain
                :loading="loading"
                @click="showPickUpWarehouseModal()">
                <v-icon>mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="pickUpWarehouseHeaders"
                :items="formData.pickUpWarehouses"
                :items-per-page="-1"
                :loading="loading"
                class="elevation-1"
                fixed-header
                hide-default-footer>
                <template #[`item.mode`]="{ item }">
                  {{ item.mode }}
                </template>
                <template #[`item.actions`]="{ item, index }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="showPickUpWarehouseModal(item)">
                    mdi-pencil
                  </v-icon>
                  <gw-icon-hover
                    small
                    class="sku-table-bin"
                    icon-name="mdi-delete"
                    icon-hover="mdi-delete-empty"
                    @click="removePickUpWarehouse(index)" />
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </validation-observer>
    <PickUpWarehouseModal
      v-model="active"
      :data="selectedItem"
      :selected-warehouses="selectedWarehouses"
      @submit="addPickUpWarehouse($event)" />
  </v-container>
</template>

<script>

import FlashExpressSettingsProvider from '@/resources/FlashExpressSettingsProvider'
import PickUpWarehouseModal from '../components/FlashPickUpWarehouseModal.vue'

const FlashExpressSettingsService = new FlashExpressSettingsProvider()

export default {
  components: {
    PickUpWarehouseModal
  },
  data () {
    return {
      loading: false,
      active: false,
      formData: {
        pickUpAddress: {
          srcName: '',
          srcPhone: '',
          srcProvinceName: '',
          srcCityName: '',
          srcDistrictName: '',
          srcPostalCode: '',
          srcDetailAddress: ''
        },
        pickUpWarehouses: []
      },
      rules: {
        required: {
          required: true
        },
        number: [
          (v) => !/^\d+&/.test(v) || 'This field must be number'
        ]
      },
      pickUpWarehouseHeaders: [
        {
          text: 'Name',
          value: 'warehouse.name',
          align: 'center',
          sortable: false
        },
        {
          text: 'Code',
          value: 'warehouse.code',
          align: 'center',
          sortable: false
        },
        {
          text: 'Pick-up Mode',
          value: 'mode',
          align: 'center',
          cellClass: 'text-capitalize',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      selectedItem: null
    }
  },
  computed: {
    selectedWarehouses () {
      return this.formData.pickUpWarehouses.map((item) => item.warehouse)
    }
  },
  mounted () {
    this.getStoreSetting()
  },
  methods: {
    async getStoreSetting () {
      try {
        this.loading = true

        const { data } = await FlashExpressSettingsService.getLastSetting()

        this.formData = {
          ...this.formData,
          ...(data || {}),
          pickUpAddress: {
            ...this.formData.pickUpAddress,
            ...(data?.pickUpAddress || {})
          }
        }
      } catch (error) {
        console.error('getStoreSetting', error)
        this.$store.dispatch('Components/setErrorPage', error.code)
      } finally {
        this.loading = false
      }
    },
    showPickUpWarehouseModal (item = null) {
      this.selectedItem = item
      this.active = true
    },
    onReset () {
      this.formData = {
        pickUpAddress: {
          srcName: '',
          srcPhone: '',
          srcProvinceName: '',
          srcCityName: '',
          srcDistrictName: '',
          srcPostalCode: '',
          srcDetailAddress: ''
        },
        pickUpWarehouses: []
      }
      this.getStoreSetting()
    },
    addPickUpWarehouse (data) {
      if (!data) {
        return
      }

      let index = this.formData.pickUpWarehouses.findIndex((item) => data.warehouse.id === item.warehouse.id)

      if (this.selectedItem) {
        index = this.formData.pickUpWarehouses.findIndex((item) => this.selectedItem.warehouse.id === item.warehouse.id)
      }

      if (index === -1) {
        this.formData.pickUpWarehouses.push(data)
      } else {
        this.$set(this.formData.pickUpWarehouses, index, data)
      }
    },
    removePickUpWarehouse (index) {
      this.formData.pickUpWarehouses.splice(index, 1)
    },
    async onSubmit () {
      try {
        this.loading = true

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          await FlashExpressSettingsService.updateSetting(this.formData)
          this.onReset()
          this.$store.dispatch('Components/setSnackbar', {
            value: true,
            message: 'Update Success',
            type: 'success'
          })
        }
      } catch (error) {
        console.error('onSubmit', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  position: sticky;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 5;
  background-color: #fff;
  padding: 1.25rem 1.875rem;
  border-radius: 0.625rem;
}
.toolbar span {
  font-weight: bold;
  font-size: 1.25rem;
}
.card-container {
  padding: 1.25rem 1.875rem;
  background-color: #fff;
  border-radius: 0.625rem;
  margin-top: 1.25rem;
}
.card-title {
  font-weight: bold;
  font-size: 1.35rem;
}
</style>
